module.exports = __webpack_public_path__ + "ab1a3b62b991fa2bc93aabf84a4f893b.jpg";